import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";
import { Reveal } from "@/lib/motion";
import { TESTIMONIALS, BUSINESS } from "@/data/site";

export const Testimonials = () => {
  return (
    <section className="relative py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-2xl mb-14">
          <Reveal as="p" className="text-xs uppercase tracking-[0.2em] text-primary font-semibold">Testimonials</Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-4 text-4xl md:text-5xl font-heading font-bold tracking-tight">
              Loved by founders & operators
            </h2>
          </Reveal>
          <Reveal delay={0.1} className="mt-4 text-muted-foreground text-lg">
            {BUSINESS.reviews} businesses across {BUSINESS.serviceArea} trust {BUSINESS.name} to power their growth.
          </Reveal>
        </div>

        <div className="columns-1 md:columns-2 lg:columns-3 gap-5 [column-fill:_balance]">
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={t.name}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.5, delay: (i % 3) * 0.06, ease: [0.22, 1, 0.36, 1] }}
              className="mb-5 break-inside-avoid rounded-2xl border border-border bg-card shadow-sm p-6 hover:border-primary/40 transition-colors"
              data-testid={`testimonial-${i}`}
            >
              <Quote className="w-7 h-7 text-primary/70" />
              <div className="mt-3 flex gap-0.5">
                {Array.from({ length: 5 }).map((_, s) => (
                  <Star key={s} className="w-4 h-4 fill-primary text-primary" />
                ))}
              </div>
              <blockquote className="mt-4 text-[15px] leading-relaxed text-foreground/80">"{t.quote}"</blockquote>
              <figcaption className="mt-5 flex items-center gap-3">
                <span className="grid place-items-center w-10 h-10 rounded-full bg-primary/15 text-primary font-heading font-bold text-sm">
                  {t.initials}
                </span>
                <div>
                  <p className="font-semibold text-sm">{t.name}</p>
                  <p className="text-xs text-muted-foreground">{t.role}</p>
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};
